<div class="bankid-section__header">
  Dina uppgifter
</div>
<div class="bankid-section__text">
  Legitimera dig för att fortsätta bokningen.
</div>

<div
  class="flex grow flex-col items-center p-4 text-center lg:justify-center"
>
  <img *ngIf="!startedLogin"
       [ngSrc]="bankIdLogo"
       alt="BankID logo"
       height="150"
       width="181"
  >
  <ng-container *ngIf="!startedLogin">
    <p class="my-4 font-medium">Logga in med mobilt BankID</p>
    <div *ngIf="mockBankId" class="my-4">
      <div class="text-error">Set personnummer (you can also enter it encrypted)</div>
      <input #debugPnoInput [value]="debugPno" class="text-center border-4 border-error min-w-full"
             name="pno" placeholder="Personnummer" type="text">
    </div>
    <app-ui-button (onClick)="startBankIdLogin(true)"
                *ngIf="isMobileDevice"
                class="mb-2 self-stretch md:self-auto"
                color="green"
                expanded="block"
    >Öppna BankID
    </app-ui-button
    >
    <app-ui-button
      (onClick)="startBankIdLogin()"
      [color]="isMobileDevice ? 'flat' : 'green'"
      class="mb-4"
      expanded="block"
    >
      <app-ui-icon color="var(--grey-1)" name="qr"></app-ui-icon>
      BankID på annan
      enhet
    </app-ui-button
    >
  </ng-container>

  <ng-container *ngIf="startedLogin">

    <div class="flex h-60 w-60 items-center justify-center">
      <qrcode *ngIf="qr" [qrdata]="qr" [width]="240"></qrcode>

      <app-spinner-circle
        *ngIf="isLoading || waitingForQr"
        [position]="CssPositionEnum.RELATIVE"
        [size]="'5rem'"
      ></app-spinner-circle>
    </div>
    <ul *ngIf="!isLoading" class="list-decimal text-left">
      <li>Öppna BankID-appen i din mobil.</li>
      <li>Tryck på QR-symbolen <img [ngSrc]="qrIcon" alt="QR-symbolen" class="inline mx-1" height="32" width="32"> i
        BankID-appen.
      </li>
      <li>Rikta kameran mot QR-koden nedan</li>
    </ul>
    <p *ngIf="isLoading">
      Skriv in din säkerhetskod i BankID- appen och välj Identifiera eller
      Skriv under.
    </p>
    <div *ngIf="qr || isLoading" class="pt-4">
      <app-ui-button
        (onClick)="cancelBankIdLogin() "
        [disabled]="loginCancelled"
        color="ghost"
        expanded="block"
      >
        Avbryt
      </app-ui-button>
    </div>
  </ng-container>
</div>
